export const apiEndpoint = `/data-push`;
